import React from 'react';
import Collapsible from 'react-collapsible';
import { Button } from 'reactstrap';
import DOMPurify from 'dompurify';
import SweetAlert from 'react-bootstrap-sweetalert';
import Slider from 'rc-slider';
import ContainerHeader from 'components/ContainerHeader/index';
import SurveyAnswerActivities from 'components/dashboard/Common/SurveyAnswerActivities/index';
import IntlMessages from 'util/IntlMessages';
import 'rc-slider/assets/index.css';
import CircularProgress from 'components/CircularProgress';
import { surveyComplete, surveyActive } from 'services/SurveyService';
import { TIGHT_FIT_PARAM } from 'constants/System';

export class Component extends React.Component {
    state = {
        menuState: false,
        currentQuestionName: '',
        currentQuestionText: '',
        currentQuestionSelected: 0,
        currentQuestionAnswerValue: 0,
        finaliseSurveyCheck: false,
        icon: 503,
        iconColour: 'blue-grey',
    };

    // onOptionMenuToggle = () => {
    //     this.setState({ menuState: !this.state.menuState });
    // };
    handleRequestClose = () => {
        const { handleAnswersMessageClose } = this.props;
        handleAnswersMessageClose();
        // this.setState({ menuState: false });
    };

    log(value) {
        console.log(value); //eslint-disable-line
    }

    componentDidMount() {
        const { currentQuestionSelected } = this.state;
        this.setCurrentQuestionAnswerValue(currentQuestionSelected);
    }

    componentDidUpdate(prevProps) {
        const { currentQuestionSelected } = this.state;
        if (this.props.empSurveyAnswers !== prevProps.empSurveyAnswers) {
            this.setCurrentQuestionAnswerValue(currentQuestionSelected);
        }
    }

    /***
     * use the current question name
     */
    currentQuestionDisplayName = () => {
        const currentQuestion = this.getCurrentQuestion();
        if (currentQuestion?.name) {
            return currentQuestion.name;
        }
        return undefined;
    };

    /***
     * use the current question name
     */
    currentQuestionDisplayText = () => {
        const currentQuestion = this.getCurrentQuestion();
        if (currentQuestion?.text) {
            return currentQuestion.text;
        }
        return undefined;
    };

    /**
     * Use the currentQuestionSelected to get the question details from the surveyQuestionList
     */
    getCurrentQuestion = () => {
        const { currentQuestionSelected } = this.state;
        const { empSurveyAnswers } = this.props;
        if (empSurveyAnswers?.answers?.length > 0) {
            const currentQuestionId = empSurveyAnswers?.answers[currentQuestionSelected].questionId;
            return this.getCurrentQuestionById(currentQuestionId);
        }
        return undefined;
    };

    /**
     * get a question by a questionid from the surveyQuestionList
     */
    getCurrentQuestionById = (questionId) => {
        const { surveyQuestionList } = this.props;
        if (questionId) {
            const currentQuestion = surveyQuestionList.filter((question) => question.id === questionId);
            if (currentQuestion?.length > 0) {
                return currentQuestion[0];
            }
        }
        return undefined;
    };

    currentQuestionPagingDisplayText = () => {
        const { currentQuestionSelected } = this.state;
        return 'Question '
            .concat(currentQuestionSelected + 1)
            .concat(' of ')
            .concat(this.currentQuestionsCount());
    };

    currentQuestionsCount = () => {
        const { empSurveyAnswers } = this.props;
        return empSurveyAnswers?.answers?.length > 0 ? empSurveyAnswers?.answers?.length : 0;
    };

    hasNextQuestion = () => {
        const { currentQuestionSelected } = this.state;
        return currentQuestionSelected < this.currentQuestionsCount() - 1;
    };

    hasPreviousQuestion = () => {
        const { currentQuestionSelected } = this.state;
        return currentQuestionSelected > 0;
    };

    setNextQuestion = () => {
        const { currentQuestionSelected } = this.state;
        const questionToSelect = currentQuestionSelected + 1;
        this.gotoQuestion(questionToSelect);
    };

    setPreviousQuestion = () => {
        const { currentQuestionSelected } = this.state;
        const questionToSelect = currentQuestionSelected - 1;
        this.gotoQuestion(questionToSelect);
    };

    gotoQuestion = (questionNumber) => {
        if (questionNumber > -1 && questionNumber < this.currentQuestionsCount()) {
            this.setState({ currentQuestionSelected: questionNumber });
            this.setCurrentQuestionAnswerValue(questionNumber);
        }
    };

    setCurrentQuestionAnswerValue = (currentQuestionSelected) => {
        const { empSurveyAnswers } = this.props;
        if (currentQuestionSelected >= 0 && currentQuestionSelected < empSurveyAnswers?.answers?.length) {
            const currentAnswerValue = empSurveyAnswers.answers[currentQuestionSelected].answer;
            this.setState({ currentQuestionAnswerValue: currentAnswerValue });
            this.setIcon(currentAnswerValue);
        }
    };

    setIcon = (value) => {
        const iconValues = {
            0: { icon: 'day-800', iconColour: 'blue-grey' },
            1: { icon: '503', iconColour: 'blue-grey' },
            2: { icon: '601', iconColour: 'blue' },
            3: { icon: 'day-701', iconColour: 'green' },
            4: { icon: 'day-801', iconColour: 'amber' },
            5: { icon: 'day-800', iconColour: 'amber' },
        };
        if (value >= 0 && value <= 5) {
            // console.log('setting values to '.concat(value).concat(' ').concat(iconValues[value].icon).concat(' ').concat(iconValues[value].iconColour));
            this.setState({
                icon: iconValues[value].icon,
                iconColour: iconValues[value].iconColour,
            });
        }
    };

    /**
     * Set the current question selected answer and return the updated answer object
     */
    getUpdatedCurrentEmpSurveyAnswers = () => {
        const { currentQuestionSelected, currentQuestionAnswerValue } = this.state;
        const { empSurveyAnswers } = this.props;
        if (empSurveyAnswers?.answers?.length > 0) {
            empSurveyAnswers.answers[currentQuestionSelected].answer = currentQuestionAnswerValue;
        }
        return empSurveyAnswers;
    };

    /**
     * Set the current question selected answer, close the survey and return the updated answer object
     */
    getUpdatedAndClosedCurrentEmpSurveyAnswers = () => {
        const empSurveyAnswers = this.getUpdatedCurrentEmpSurveyAnswers();
        empSurveyAnswers.surveyClosedDate = new Date();
        return empSurveyAnswers;
    };

    // TODO not working 100% - notification not showing (but do we want that anyway??), etc
    // showOrgSurveyAnswersLoader not showing yet, etccc
    onGotoQuestionClick = (index) => {
        const { showOrgSurveyAnswersLoader, saveEmpSurveyAnswers, empSurveyAnswers } = this.props;
        if (!surveyComplete(empSurveyAnswers)) {
            showOrgSurveyAnswersLoader();
            saveEmpSurveyAnswers(this.getUpdatedCurrentEmpSurveyAnswers());
        }
        this.gotoQuestion(index);
    };

    getQuestionAnswerList = () => {
        const { empSurveyAnswers } = this.props;
        if (empSurveyAnswers?.answers?.length > 0) {
            const empSurveyAnswersList = empSurveyAnswers.answers.map((empSurveyAnswer, index) => {
                if (empSurveyAnswer?.questionId) {
                    const questionById = this.getCurrentQuestionById(empSurveyAnswer.questionId);
                    if (questionById) {
                        return {
                            image: empSurveyAnswer.answer > 0 ? 'check' : 'minus',
                            title: questionById ? questionById.name : '???',
                            clickEvent: () => {
                                this.onGotoQuestionClick(index);
                            },
                            color: empSurveyAnswer.answer > 0 ? 'green' : 'amber',
                            borderColor: empSurveyAnswer.answer > 0 ? 'green' : 'amber',
                        };
                    }
                }
            });
            return empSurveyAnswersList;
        }
        return [];
    };

    render() {
        const { currentQuestionAnswerValue, finaliseSurveyCheck, icon, iconColour } = this.state;
        const { answersloader, emploader, saveEmpSurveyAnswers, showOrgSurveyAnswersLoader, empSurveyAnswers } = this.props;
        // const style = { width: 400, margin: 20 };
        const marks = {
            0: currentQuestionAnswerValue > 0 ? 'Selected' : { style: { color: 'red' }, label: <strong>Select</strong> },
            1: currentQuestionAnswerValue === 1 ? { style: { color: 'green' }, label: <strong>Blocked</strong> } : 'Blocked',
            2: currentQuestionAnswerValue === 2 ? { style: { color: 'green' }, label: <strong>Developing</strong> } : 'Developing',
            3: currentQuestionAnswerValue === 3 ? { style: { color: 'green' }, label: <strong>Emerging</strong> } : 'Emerging',
            4: currentQuestionAnswerValue === 4 ? { style: { color: 'green' }, label: <strong>Adapting</strong> } : 'Adapting',
            5: currentQuestionAnswerValue === 5 ? { style: { color: 'green' }, label: <strong>Optimizing</strong> } : 'Optimizing',
        };

        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                {emploader || answersloader ? (
                    <div className="loader-view" style={{ height: this.props.width >= 1200 ? 'calc(100vh - 266px)' : 'calc(100vh - 246px)' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <React.Fragment>
                        <div className="ml-3 mt-3">
                            <ContainerHeader
                                match={this.props.match}
                                title={surveyActive(empSurveyAnswers) ? <IntlMessages id="orgEmpSurvey.activeSurvey" /> : <IntlMessages id="orgEmpSurvey.inactiveSurvey" />}
                            />
                        </div>
                        <div className="row">
                            <div className="col-md-9 col-12">
                                <div className="jr-card ml-2 mr-2">
                                    <div className="jr-card-header d-flex">
                                        <div className="mr-auto">
                                            <h3 className="card-heading">
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.currentQuestionDisplayName()) }} />
                                            </h3>
                                            <p className="sub-heading">{this.currentQuestionPagingDisplayText()}</p>
                                        </div>
                                    </div>

                                    <div className="jr-card-body">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                                    <p>
                                                        <i className={'detail-icon text-' + iconColour + ' wi wi-owm-' + icon} />
                                                    </p>
                                                </div>
                                            </div>
                                            <div key="surveyQuestion" className="col-sm-9 text-left text-sm-left">
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.currentQuestionDisplayText()) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="jr-card ml-2 mr-2">
                                    <div className="jr-card-header d-flex justify-content-between">
                                        <div>
                                            <h3 className="card-heading">
                                                <IntlMessages id="orgEmpSurvey.answerHeader" />
                                            </h3>
                                            <div>
                                                <div style={{ width: this.props.width > 700 ? this.props.width - 570 : 300, margin: this.props.width > TIGHT_FIT_PARAM ? 20 : 2 }}>
                                                    <Slider
                                                        max={5}
                                                        marks={marks}
                                                        onChange={(value) => {
                                                            // this.log(value);
                                                            this.setState({ currentQuestionAnswerValue: value });
                                                            this.setIcon(value);
                                                        }}
                                                        value={currentQuestionAnswerValue}
                                                        disabled={!surveyActive(empSurveyAnswers)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="modal-box-footer d-flex flex-row">
                                        <Button
                                            className="text-uppercase"
                                            id="prevButton"
                                            disabled={!this.hasPreviousQuestion()}
                                            color="primary"
                                            onClick={() => {
                                                if (surveyActive(empSurveyAnswers)) {
                                                    showOrgSurveyAnswersLoader();
                                                    saveEmpSurveyAnswers(this.getUpdatedCurrentEmpSurveyAnswers());
                                                }
                                                this.setPreviousQuestion();
                                            }}
                                        >
                                            <IntlMessages id="orgEmpSurvey.previousQuestion" />
                                        </Button>
                                        <Button
                                            className="text-uppercase"
                                            id="nextButton"
                                            disabled={!this.hasNextQuestion()}
                                            color="primary"
                                            onClick={() => {
                                                if (surveyActive(empSurveyAnswers)) {
                                                    showOrgSurveyAnswersLoader();
                                                    saveEmpSurveyAnswers(this.getUpdatedCurrentEmpSurveyAnswers());
                                                }
                                                this.setNextQuestion();
                                            }}
                                        >
                                            <IntlMessages id="orgEmpSurvey.nextQuestion" />
                                        </Button>
                                        {surveyActive(empSurveyAnswers) ? (
                                            surveyComplete(empSurveyAnswers) ? (
                                                <Button
                                                    className="text-uppercase"
                                                    id="finishButton"
                                                    color="primary"
                                                    onClick={() => {
                                                        this.setState({ finaliseSurveyCheck: true });
                                                    }}
                                                >
                                                    <IntlMessages id="orgEmpSurvey.saveAndCloseSurvey" />
                                                </Button>
                                            ) : (
                                                <Button
                                                    className="text-uppercase"
                                                    id="gotoButton"
                                                    color="primary"
                                                    onClick={() => {
                                                        showOrgSurveyAnswersLoader();
                                                        saveEmpSurveyAnswers(this.getUpdatedCurrentEmpSurveyAnswers());
                                                    }}
                                                >
                                                    <IntlMessages id="orgEmpSurvey.saveSurvey" />
                                                </Button>
                                            )
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="jr-card jr-card-full-height ml-2 mr-2">
                                    <Collapsible trigger={<IntlMessages id="dashboard.gotoQuestion" />}>
                                        {this.getQuestionAnswerList().map((questionAnswerList, index) => (
                                            <SurveyAnswerActivities key={index} recentData={questionAnswerList} />
                                        ))}
                                    </Collapsible>
                                </div>
                            </div>
                        </div>

                        {/* {showMessage && NotificationManager.success(alertMessage, this.handleRequestClose())}
                        <NotificationContainer /> */}
                        <SweetAlert
                            style={{ width: this.props.width > TIGHT_FIT_PARAM ? 500 : 300 }}
                            show={finaliseSurveyCheck}
                            custom
                            showCancel
                            confirmBtnText={<IntlMessages id="button.yes" />}
                            cancelBtnText={<IntlMessages id="button.no" />}
                            confirmBtnBsStyle="primary"
                            cancelBtnBsStyle="default"
                            customIcon="assets/images/online-survey.jpeg"
                            title={<IntlMessages id="general.areYouSure" />}
                            onConfirm={() => {
                                saveEmpSurveyAnswers(this.getUpdatedAndClosedCurrentEmpSurveyAnswers());
                                this.setState({ finaliseSurveyCheck: false });
                            }}
                            onCancel={() => {
                                this.setState({ finaliseSurveyCheck: false });
                            }}
                        >
                            <IntlMessages id="orgEmpSurvey.finaliseSurveyWarning" />
                        </SweetAlert>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/OrgEmpSurvey/Component.js